import { HealthPackageItem } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";

type TPutPackageConfigPayload = Omit<
  HealthPackageItem,
  | "total_price"
  | "package_expiry_from_start"
  | "created_at"
  | "modified_at"
  | "created_by"
> &
  Partial<Pick<HealthPackageItem, "total_price" | "package_expiry_from_start">>;

export default async function putUpdateAPackage({
  data,
}: {
  data: TPutPackageConfigPayload;
}): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const headers = new Headers();

    headers.append("accept", "application/json");
    headers.append("Content-Type", "application/json");

    const body = JSON.stringify({
      payload: data,
    });

    const requestOptions: RequestInit = {
      method: "PUT",
      body,
      headers,
      credentials: "include",
    };

    const response = await fetch(
      `${TRYST_HOST}/package/config/${data.package_id}`,
      requestOptions
    );

    const resp = await response.json();
    return resp;
  } catch (error) {
    console.error("ERROR =====> putUpdateAPackage", error);
    return { success: false };
  }
}
